
function DictionaryField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, Classes, $injector, $uibModal, $q, $translate, FormService) {
			var self = this;
		
			this.target_identity = null;
			this.currentItem = null;
			this.currentItemIndex = null;
			this.items = [];
			this.dictInitialized = false;
			this.dictRequestEssentialDataJson = null;  // aby sprawdzać, czy trzeba robić reload dict
			this.reloadDict = false;
			this.isDictLoading = false;
			
			this.dictionaryAsPairs = function(dict) {
				if (dict.length) return dict;
				var ret = [];
				for (var key in dict) {
					ret.push([key, dict[key]]);
				}
				return ret;
			}
			
			this.setupPairs = function(items) {
				this.items = [];
				for (var i=0; i<items.length; i++) {
					var item = {
						value: items[i][0],
						title: items[i][1],
					}
					this.items.push(item);
				}
				this.dictInitialized = true;
			}
			
			this.setupObjects = function(objects) {
				this.items = [];
				for (var i=0; i<objects.length; i++) {
					var item = {
						//value: objects[i],
						value: (objects[i].__class && Classes[objects[i].__class])? Classes[objects[i].__class].getObjectPayload(objects[i]) : objects[i],
						object: objects[i],
						title: this.getObjectTitle(objects[i]),
					}
					this.items.push(item)
				}
				this.dictInitialized = true;
			}
			
			this.getObjectTitle = function(object) {
				if (this.field.client && this.field.client.title) {
					var title_expr = this.field.client.title;
					var title = $parse(title_expr);
					return title(object, window);
				} else {
					return object? object.__title : null;
				}
			}
			
			
			
			this.getEssentialData = function() {
				if (this.object.__class && Classes[this.object.__class]) {
					var klass = Classes[this.object.__class];
					if (klass) {
						return klass.getObjectPayload(this.object, 'essential');
					}
				}
				return this.object;
			}
			
			this.updateDict = function() {
				self.dictRequestEssentialDataJson = angular.toJson(self.getEssentialData())
				self.isDictLoading = true;
				return (this.field.dict)({
					filter:{},
					data: self.getEssentialData()
				}).then(function(items){
					if (self.reloadDict) {
						// nastapiła zmiana depends w czasie trwania request
						console.debug('Reloading dict', self.field.name)
						self.reloadDict = false;
						return self.updateDict();
					}
					if (items && items.length && items[0].__class) {
						self.setupObjects(items);
						self.target_identity = (self.field.client && self.field.client.identity)? self.field.client.identity : '__vid';
					} else {
						self.setupPairs(items);
						self.target_identity = null;
					}
					// set null if new value doesn't contain the selected item
					var found = false;
					for (var i=0; i<self.items.length; i++) {
						if (self.object[self.field.name] == self.items[i].value || 
							(self.target_identity && self.object[self.field.name] && self.object[self.field.name][self.target_identity] == self.items[i].value[self.target_identity])) 
						{
							found = true;
							self.items[i].value = self.object[self.field.name]  // link selected item value to the current value
							self.currentItem = self.items[i];
							self.currentItemIndex = i;
						}
					}
					if (!found) self.object[self.field.name] = null;
					self.isDictLoading = false;
					return items;
				})
			}
			
			this.setDefault = function() {
				if (self.object.__id) return;
				if (self.items.length == 1) {
					self.object[self.field.name] = self.items[0].value;
				}
			}
			
			if (this.field.depends || !this.field.dictionary) {
				var depends = $parse(this.field.depends);
				var getDepends = function() {
					var ret = depends(self.object);
					if (!ret) return [null];
					return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
				}
				self.updateDict().then(self.setDefault);
				$scope.$watchCollection(getDepends, function(x){
					//if (self.dictInitialized) self.updateDict().then(self.setDefault);
					if (self.isDictLoading && self.dictRequestEssentialDataJson != angular.toJson(self.getEssentialData())) {
						self.reloadDict = true;
					} else if (!self.isDictLoading) {
						self.updateDict().then(self.setDefault);
					}
				});
				
			} else {
				var pairs = this.dictionaryAsPairs(this.field.dictionary);
				this.setupPairs(pairs);
			}

			$scope.$watch(function(){return self.object[self.field.name]}, function(values, old){
				//console.debug("Update watch for field fired:", self.field.name);
				if (values == old) return;
				if (!self.dictInitialized) return;
				if (true || self.target_identity) {
					// set null if new value doesn't contain the selected item
					var found = false;
					for (var i=0; i<self.items.length; i++) {
						if (self.object[self.field.name] == self.items[i].value || 
							(self.target_identity && self.object[self.field.name] && self.items[i].value && self.object[self.field.name][self.target_identity] == self.items[i].value[self.target_identity])) 
						{
							found = true;
							self.items[i].value = self.object[self.field.name]  // link selected item value to the current value
							self.currentItem = self.items[i];
							self.currentItemIndex = i;
						}
					}
					if (!found) {
						self.object[self.field.name] = null;
						self.currentItem = null;
						self.currentItemIndex = null;
					}
				}
			});


			// suport images selector
			this.append_new = function(data) {
				if (self.field.client && self.field.client.type == 'image') {
					var item = {
						value: data,
						object: {download: [{href: data.data, thumb: data.data}], __title: data.filename},
						title: data.filename,
					}
					self.object[self.field.name] = item.value;
					this.items.push(item);
				} else if (self.field.join.foreignClass) {
					var classname = self.field.join.foreignClass;
					var item = {
						value: data,
						object: Classes[classname]? Classes[classname].create(data) : data,
						title: self.getObjectTitle(data) || data.title || $translate.instant('New object')
					}
					self.object[self.field.name] = item.value;
					this.items.push(item);
				}
			}

			this.imageSelectDialog = function() {
				var classname = self.field.join.foreignClass;
				if ($injector.has('ContextService')) {
					var module = $injector.get('ContextService').getContext(classname);
				} else {
					var module = null;
				}
				var dlg = $uibModal.open({
					animation: true,
					templateUrl: 'framework/partials/forms/field-dialog-referencefield-images.html',
					controller: 'SubmitCancelDialogCtrl as dCtrl',
					size: 'lg',
					resolve: {
						params: function ($q) {
						return $q.all({
							data: {
								items: self.items, 
								selected: self.object[self.field.name],
								moduleName: module.getName(), 
								imageMode: (self.field.client && self.field.client.imagemode)? self.field.client.imagemode : 'cover',  // contain
							},
							submit:function(data) {
								self.object[self.field.name] = data.selected;
								return $q.resolve(data.selected);
							},
						});
						}
					}
				});
			}

			this.createNewDialog = function(layout, savegroups, defaults) {
				savegroups = savegroups || ['edit'];
				layout = layout || savegroups;
				defaults = defaults || {}
				var classname = self.field.join.foreignClass;
				if ($injector.has('ContextService')) {
					var module = $injector.get('ContextService').getContext(classname);
				}

				var fields = Classes[classname].get_fields(savegroups)
				var formconfig = {
					title: module? module.getTitle(): 'New item',
					btn: module? module.getCreateLabel() : 'Create',
					params: Classes[classname].get_form_params(null, fields),
					submit: function(data) {
						return Classes[classname].validate(data).then(function(){
							self.append_new(data);
							return $q.resolve(data);
						});
					},
					layout: layout,
				}
				return FormService.activateFormModal(formconfig, defaults);
			}
			
			window.dictCtrls = window.dictCtrls || [];
			window.dictCtrls.push(this);
			
		},
		controllerAs: '$dict'
	}
}


function DictionaryMap() {
	return {
		bindToController: {
			items: '<',
			field: '<',
			defaultAddress: '@',
			coords: '@',
			pinColor: '@',
			labelExpression: '@',
			object: '=fieldObject',
		},
		controller: function DictionaryMapCtrl($parse, $scope, FormService, $q) {
			var self = this;
			self.markers = [];
			this.geocodeAddress = '';
			this.geocodeAddressError = false;

			this.map = {
				show: true,
				control: {},
				position: {},
				zoom: 6,
				events: {
					click: function(map, type, args){
						/*$scope.$apply(function(){
							console.log('map click', args);
							self.object[self.field.name] = self.object[self.field.name] || {}
							self.object[self.field.name].latitude = args[0].latLng.lat();
							self.object[self.field.name].longitude = args[0].latLng.lng();
						})*/
					}
				},
				marker: {
					position: {},
					events: {
						/*dragend: function(map, type, args){
							$scope.$apply(function(){
								console.log('drag end', args);
								self.object[self.field.name].latitude = args.gMarker.position.lat();
								self.object[self.field.name].longitude = args.gMarker.position.lng();
							})
						}*/
					}
				}
			}
			
			self.map.position = {latitude:52,longitude:19};

			// http://stackoverflow.com/questions/7095574/google-maps-api-3-custom-marker-color-for-default-dot-marker
			var custom_icon = function(pinColor, selected, icon) {
				pinColor = pinColor || 'FE7569';
				starColor = 'ffff00';
				icon = icon || 'home';
				var style = selected? 'pin_star' : 'pin';
				//var icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|" + pinColor;
				var icon_url = "http://chart.apis.google.com/chart?chst=d_map_xpin_icon&chld=" 
					+style+ "|" +icon+ "|" + pinColor+ "|" + starColor;
				return icon_url;
			}

			$scope.$watchCollection(function(){return self.items}, function(items) {
				self.markers.length = 0;
				var coords_func = $parse(self.coords);
				var pinColor_func = $parse(self.pinColor);
				var labelExpression_func = $parse(self.labelExpression);
				for (var i=0; i<items.length; i++) {
					var item = items[i];
					if (!item.value[self.coords]) {
						continue;
					}
					self.markers.push({
						id: item.value.__id,
						position: coords_func(item.value),
						title: item.title,
						value: item.value,
						options: self.labelExpression? {labelClass:'label label-default',labelAnchor:/*'12 60'*/ '-5 5' ,labelContent:labelExpression_func(item.value)} : {},
						pinColor: pinColor_func(item.value),
						icon: custom_icon(pinColor_func(item.value), false)
					});
				}
			});
			if (self.defaultAddress) {
				var func = $parse(self.defaultAddress);
				$scope.$watch(function(){return func(self.object);}, function(addr){
					self.geocodeAddress = addr;
				})
			}
			$scope.$watch(function(){return self.object[self.field.name];}, function(value) {
				var pinColor_func = $parse(self.pinColor);
				for (var i=0; i<self.markers.length; i++) {
					var marker = self.markers[i];
					marker.icon = custom_icon(pinColor_func(marker.value), value? marker.id == value.__id : false);
				}
			}, true);

			self.select = function(marker, eventName, model, mousearg) {
				self.object[self.field.name] = model.value;
			}
			
			self.refresh = function(){
				if (self.map.control.refresh) {
					self.map.control.refresh();
					self.map.control.getGMap().setCenter({lat: self.map.position.latitude, lng: self.map.position.longitude});
				}
			}
			
			self.geocode = function(address) {
				console.log('Geocoding', address);
				var geocoder = new google.maps.Geocoder;
				geocoder.geocode({address: address}, function(results, status) {
					$scope.$apply(function(){
						if (status == 'OK') {
							var latlng = results[0].geometry.location;
							self.map.control.getGMap().setCenter(latlng);
							self.map.control.getGMap().setZoom(15);
							self.geocodeAddressError = false;
						} else {
							
							self.geocodeAddressError = 'Not found';
						}
					})
					
				});
			}
			
			$scope.$on('editTabOn', function(){
				self.map.show = true;
				setTimeout($scope.refresh, 10);
			});
			
			window.$map = self;

		},
		controllerAs: '$map'
	}
}


// deprecated
function DictionaryFieldController($scope) {

	var self = this;
	// field.dictionary może mieć postać {a: "b"} lub [["a","b"]]. 
	// Potrzebujemy tą drugą do listy opcji w edycji.
	this.dictionaryAsPairs = function(dict) {
		if (dict.length) return dict;
		var ret = [];
		for (var key in dict) {
			ret.push([key, dict[key]]);
		}
		return ret;
	}
	
	// field.dictionary może mieć postać {a: "b"} lub [["a","b"]]. 
	// Potrzebujemy tą pierwszą do przerabiania value => title w widokach.
	this.dictionaryAsMap = function(dict) {
		if (typeof dict.length == "number") {
			var ret = {};
			for (var i=0; i<dict.length; i++) {
				ret[dict[i][0]] = dict[i][1];
			}
			return ret;
		} else {
			return dict;
		}
	}
	
	this.titleForKey = function(dict, key) {
		if (key === null) return null;
		var dict = self.dictionaryAsMap(dict);
		if (typeof key == "string" || typeof key == "number") {
			return dict.hasOwnProperty(key)? dict[key] : null;
		} else {
			var titles = [];
			for (var i=0; i<key.length; i++) {
				titles.push(dict.hasOwnProperty(key[i])? dict[key[i]] : null);
			}
			return titles.join(', ');
		}
	}
	
	this.toggleOption = function(values, option) {
		var pos = values.indexOf(option);
		if (pos >= 0) {
			values.splice(pos,1);
		} else {
			values.push(option);
		}
		return values;
	}
	
	this.hasOption = function(values, option) {
		return (values||[]).indexOf(option) >= 0;
	}
}


angular.module('forms.fields.dictionary', [])
.directive('dictionaryField', DictionaryField)
.controller('DictionaryFieldController', DictionaryFieldController)
.directive('dictionaryMap', DictionaryMap)


